<template>
  <li class="divider"></li>
</template>
<script>
  export default {
    name: 'NavbarNavDropdownDivider'
  }
</script>



// WEBPACK FOOTER //
// navbar-nav-dropdown-divider.vue?3eb85c6a